<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.26 19.14L12.93 5.33a2.07 2.07 0 00.33-1.94 2.26 2.26 0 00-2-1.31 5.82 5.82 0 00-2.59.41 5.89 5.89 0 00-2.25 1.44 2.27 2.27 0 00-.63 2.33 2.08 2.08 0 001.54 1.21l5.33 13.83a1 1 0 00.53.56 1.14 1.14 0 00.4.08.94.94 0 00.37-.07l3.73-1.44a1 1 0 00.57-1.29zm-8.8-11.7a7 7 0 001-.28 8.56 8.56 0 00.91-.43l1.91 4.95-2.05.26zm-.12-3.08a3.3 3.3 0 012-.23A3.33 3.33 0 019.7 5.29a3.19 3.19 0 01-2 .23 3.33 3.33 0 011.64-1.16zm4.83 15.29l-2.61-6.75 2-.25L16 18.93z"/></svg>